import { useTranslation } from 'react-i18next'
import { WizardState } from '../types/index'

interface Props {
  state: WizardState
  updateState: (updates: Partial<WizardState>) => void
}

export function Step1({ state, updateState }: Props) {
  const { t } = useTranslation()
  return (
    <div style={{ width: '100%', maxWidth: 560, textAlign: 'center' }}>
      <h1 style={{ fontSize: 32, fontWeight: 800, color: '#111827', marginBottom: 8 }}>{t('step1.title')}</h1>
      <p style={{ color: '#6B7280', marginBottom: 48, fontSize: 16 }}>{t('step1.subtitle')}</p>
      <div style={{ display: 'flex', justifyContent: 'center', gap: 16, flexWrap: 'wrap' }}>
        {[1, 2, 3, 4, 5, 6].map(n => (
          <button
            key={n}
            onClick={() => updateState({ examCount: n })}
            style={{
              width: 72, height: 72,
              borderRadius: 16,
              fontSize: 26, fontWeight: 700,
              border: state.examCount === n ? 'none' : '2px solid #E5E7EB',
              backgroundColor: state.examCount === n ? '#1c3fff' : 'white',
              color: state.examCount === n ? 'white' : '#374151',
              cursor: 'pointer',
              boxShadow: state.examCount === n
                ? '0 4px 14px rgba(28,63,255,0.35)'
                : '0 1px 3px rgba(0,0,0,0.08)',
              transform: state.examCount === n ? 'scale(1.08)' : 'scale(1)',
              transition: 'all 0.15s ease',
              outline: 'none'
            }}
          >
            {n}
          </button>
        ))}
      </div>
    </div>
  )
}
